/**
 * Schedule Constants
 * Centralized constants for recurring schedule functionality
 */

import type { RecurrenceFrequency } from '../../../shared/types';

/**
 * Days of the week with short labels for UI display
 */
export const DAYS_OF_WEEK = [
  { value: 0, label: 'Sun' },
  { value: 1, label: 'Mon' },
  { value: 2, label: 'Tue' },
  { value: 3, label: 'Wed' },
  { value: 4, label: 'Thu' },
  { value: 5, label: 'Fri' },
  { value: 6, label: 'Sat' },
] as const;

/**
 * Full day names for detailed display
 */
export const DAY_NAMES_FULL = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
] as const;

/**
 * Short day names for compact display
 */
export const DAY_NAMES_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] as const;

/**
 * Recurrence frequency options for select fields
 */
export const FREQUENCY_OPTIONS: { value: RecurrenceFrequency; label: string }[] = [
  { value: 'weekly', label: 'Weekly' },
  { value: 'biweekly', label: 'Every 2 Weeks' },
  { value: 'daily', label: 'Daily' },
  { value: 'monthly', label: 'Monthly' },
];

/**
 * Default working days (Monday-Friday)
 */
export const DEFAULT_WORKING_DAYS = [1, 2, 3, 4, 5] as const;

/**
 * Default schedule times
 */
export const DEFAULT_SCHEDULE_TIMES = {
  startTime: '09:00',
  endTime: '17:00',
} as const;
